module.exports={
	"Form": "AccountViewManifest",
	"Scope": "Account-View",
	"Descriptors":
	{
		"AccountDetails.Name":
		{
			"Name": "Name",
			"Hash": "Account-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Account-View-Identity",
				"Group": "Account-View-Identity"
			}
		},
		"AccountDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Account-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details"
			}
		},
		"AccountDetails.Description":
		{
			"Name": "Description",
			"Hash": "Account-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details"
			}
		},
		"AccountDetails.IDAccountType":
		{
			"Name": "Account Type",
			"Hash": "Account-View-IDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details",
				"Entity": "AccountType",
				"SearchFields":
				[
					"Name",
					"EntityName",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"AccountDetails.EntityName":
		{
			"Name": "Entity Name",
			"Hash": "Account-View-EntityName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details"
			}
		},
		"AccountDetails.IDEntity":
		{
			"Name": "IDEntity",
			"Hash": "Account-View-IDEntity",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details"
			}
		},
		"AccountDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "Account-View-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details"
			}
		},
		"AccountDetails.Pending":
		{
			"Name": "Pending",
			"Hash": "Account-View-Pending",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details"
			}
		},
		"AccountDetails.IDAccount":
		{
			"Name": "IDAccount",
			"Hash": "Account-View-IDAccount",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Account-View-DataAudit",
				"Group": "Account-View-DataAudit"
			}
		},
		"AccountDetails.GUIDAccount":
		{
			"Name": "GUIDAccount",
			"Hash": "Account-View-GUIDAccount",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Account-View-DataAudit",
				"Group": "Account-View-DataAudit"
			}
		},
		"AccountDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Account-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Account-View-DataAudit",
				"Group": "Account-View-DataAudit"
			}
		},
		"AccountDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Account-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Account-View-DataAudit",
				"Group": "Account-View-DataAudit"
			}
		},
		"AccountDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Account-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Account-View-DataAudit",
				"Group": "Account-View-DataAudit"
			}
		},
		"AccountDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Account-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Account-View-DataAudit",
				"Group": "Account-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Account-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Account-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Account-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Account-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Account-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Account-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
